import { useQuery } from "@apollo/client";
import { Link, useParams } from "react-router-dom";
import GET_TRAINEESHIP_PDF from "../../../../../graphql/queries/traineeships/traineeshipPdf";
import withTitle from "../../../../../components/withTitle";
import { useTranslation } from "react-i18next";

const ExportTraineeshipPdf = () => {
  const { traineeshipID } = useParams();
  const { t } = useTranslation();

  const { loading, data, error } = useQuery(GET_TRAINEESHIP_PDF, {
    variables: {
      ID: traineeshipID,
    },
  });

  if (error) {
    return t('errorMessage');
  }

  if (!loading) {
    let pdf = data?.traineeshipPdf?.file;

    if (pdf) {
      let byteCharacters = atob(pdf);
      let byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      let byteArray = new Uint8Array(byteNumbers);
      let file = new Blob([byteArray], { type: "application/pdf;base64" });
      const fileURL = URL.createObjectURL(file);

      return (
        <>
          <object
            style={{ width: "100%", height: "100vh" }}
            type="application/pdf"
            data={fileURL}
          >
            <p>
              {t('traineeshipPdf.download.part1')}<Link to={fileURL}>{t('traineeshipPdf.download.part2')}</Link>.
            </p>
          </object>
        </>
      );
    }
  }
};

export default withTitle(
  ExportTraineeshipPdf,
  "Export Traineeship to PDF"
);